/* tslint:disable */
/* eslint-disable */
/**
 * Local Map - Local Map Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.3
 * Contact: local-map@daangn.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../runtime';
import type { V1UserLocation } from './V1UserLocation';
import {
    V1UserLocationFromJSON,
    V1UserLocationFromJSONTyped,
    V1UserLocationToJSON,
} from './V1UserLocation';

/**
 * 
 * @export
 * @interface V1CreateUserLocationResponse
 */
export interface V1CreateUserLocationResponse {
    /**
     * 
     * @type {V1UserLocation}
     * @memberof V1CreateUserLocationResponse
     */
    userLocation: V1UserLocation;
}

/**
 * Check if a given object implements the V1CreateUserLocationResponse interface.
 */
export function instanceOfV1CreateUserLocationResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "userLocation" in value;

    return isInstance;
}

export function V1CreateUserLocationResponseFromJSON(json: any): V1CreateUserLocationResponse {
    return V1CreateUserLocationResponseFromJSONTyped(json, false);
}

export function V1CreateUserLocationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1CreateUserLocationResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userLocation': V1UserLocationFromJSON(json['user_location']),
    };
}

export function V1CreateUserLocationResponseToJSON(value?: V1CreateUserLocationResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_location': V1UserLocationToJSON(value.userLocation),
    };
}

